import { AttributeLabelsState } from "@idw-types/state/attribute-labels-state";
import { getAttributeLabelsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getAttributeLabelsDataState = createSelector(getAttributeLabelsState, (state: AttributeLabelsState) => {
    return {
        isLoadingAxnAttributeLabels: state.attributeLabels.isLoading,
        axnAttributeLabels: state.attributeLabels.attributeLabels
    };
});